'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactUtils = require('react-utils');

var _UIAbstractPageSection = require('../page/UIAbstractPageSection');

var _UIAbstractPageSection2 = _interopRequireDefault(_UIAbstractPageSection);

var _UIStickyFooter = require('./UIStickyFooter');

var _UIStickyFooter2 = _interopRequireDefault(_UIStickyFooter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

exports.default = _react2.default.createClass({
  displayName: 'UIFixedSaveBar',

  propTypes: _UIStickyFooter2.default.propTypes,

  getDefaultProps: function getDefaultProps() {
    return _UIStickyFooter2.default.defaultProps;
  },
  render: function render() {
    var _props = this.props,
        children = _props.children,
        className = _props.className,
        rest = _objectWithoutProperties(_props, ['children', 'className']);

    return _react2.default.createElement(
      _UIStickyFooter2.default,
      _extends({}, rest, {
        className: (0, _reactUtils.classNames)('private-fixed-save-bar', className)
      }),
      _react2.default.createElement(
        _UIAbstractPageSection2.default,
        { className: 'private-fixed-save-bar__inner' },
        children
      )
    );
  }
});
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.1282/js/panel/UIFixedSaveBar.js
// module id = 358
// module chunks = 0